/**
 * Route des alertes selon le module courant — une seule logique pour Header + TopBar.
 * @param {string} pathname
 * @returns {string}
 */
export function getModuleAlertesPath(pathname) {
  const p = pathname || '';
  if (p.startsWith('/ventes')) return '/ventes/alertes';
  if (p.startsWith('/marketing')) return '/marketing/alertes';
  if (p.startsWith('/treasury') || p.startsWith('/caisse')) return '/treasury/alertes';
  if (p.startsWith('/banking') || p.startsWith('/banque')) return '/banking/alertes';
  return '/dashboard/alertes';
}
